import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  OnChanges,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef
} from "@angular/core";
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { AccountLookupService } from "./account-lookup.service";
import {
  startWith,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  map
} from "rxjs/operators";
import { DataService } from "../../../../core/services";
import { CommonBaseComponent } from "../common-base.component";
import { AccountType } from "../../../../shared/enums/data.enums";
import {
  MedicalSchool,
  Residency,
  Fellowship
} from "../../../../shared/models/my-account-data.models";

declare var $;

@Component({
  selector: "app-account-lookup",
  templateUrl: "./account-lookup.component.html",
  styleUrls: ["./account-lookup.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [AccountLookupService]
})
export class AccountLookupComponent extends CommonBaseComponent {
  filteredAccounts: any[];
  accounts: any[];
  title: any;
  manualId: any;
  private _accountType: AccountType;
  get name() {
    return this.accountLookUp.get("name");
  }
  get id() {
    return this.accountLookUp.get("id");
  }

  get ID()
  {
    return this.id.value;
  }
  set ID(value: any)
  {
     this.id.setValue(value);
  }
  
  get NAME()
  {
    return this.name.value;
  }
  set NAME(value)
  {
    this.name.setValue(value);
  }

  //INPUTS
  @Input() accountLookUp: FormGroup;
  @Input()
  set accountType(value: AccountType) {
    this._accountType = value;
    this.updateAccountsDataSource();
  }
  get accountType(): AccountType {
    return this._accountType;
  }
  //OUTPUTS
  @Output() onSelect = new EventEmitter<any>();

  @ViewChild("Program") autosuggestfield: ElementRef;

  ngOnInit() {
    this.updateAccountsDataSource();
  }

  ngAfterViewInit() {
    this.initAutoComplete();
  }

  updatemodel(item) {
    this.id.setValue(item.data("id"));
    let enteredsearchtext = this.name.value;
    let isManual = item.data("id") == this.manualId;
    // this.medicalschool.address = new Address();
    this.NAME = (isManual ? enteredsearchtext : item.data("name"));

    this.onSelect.emit(isManual);
  }

  clearifnotypeahead() {
    if (this.id.value == "" && this.name.value != "") {
      this.NAME = '';
      this.globalDomOpsService.notify(
        "Please select a Program from the selection",
        "",
        "warning"
      );
    }
  }

  namevaluechange(newValue) {
    if (newValue.length == 0) {
      this.ID = '';
    }
  }

  resetIfNotValid() {
    //Clear the autosuggest field if not selected from dropdown and tabbed out
    if (this.ID == '') {
      this.NAME = '';
    }
  }

  isManualAccount(_name: any): boolean {
    return _name.indexOf("I DO NOT") > -1;
  }

  updateAccountsDataSource() {
    let _accountType: string = "";
    switch (this.accountType) {
      case AccountType.MEDICALSCHOOL: {
        this.accounts = this.dataService.uidata.MedicalSchools;
        _accountType = "MEDSCHOOL";

        this.title = "Medical School";

        break;
      }
      case AccountType.RESIDENCY: {
        this.accounts = this.dataService.uidata.Residencies;
        _accountType = "RESIDENCY";
        this.title = "Residency";
        break;
      }
      case AccountType.FELLOWSHIP: {
        this.accounts = this.dataService.uidata.Fellowships;
        _accountType = "FELLOWPROG";
        this.title = "Fellowship";
        break;
      }
      // case AccountType.BOARDCERTIFICATION: {
      //   this.accounts = of(this.dataService.uidata.BoardCertifications);
      //   _accountType = "FELLOWPROG";
      //   break;
      // }
      default: {
        // this.accounts = [];
        this.accounts = [
          ...this.dataService.uidata.MedicalSchools,
          ...this.dataService.uidata.Residencies,
          ...this.dataService.uidata.Fellowships
        ];
        break;
      }
    }

    this.manualId =
      this.dataService.uidata.ManualAccounts.filter(
        s => s.acep_code === _accountType
      )[0].accountId + "";
  }

  

  


  initAutoComplete() {
    let this_component = this;
    let choices = this.accounts;
    $(this.autosuggestfield.nativeElement).autoComplete({
      minChars: 3,
      delay: 100,
      source: function(term, suggest) {
        term = term.toLowerCase();

        //let choices = this.ui_account;
        let suggestions = [];
        let choice: any = "";
        for (let i = 0; i < choices.length; i++) {
          choice = choices[i];
          //console.log(choice.name);
          if (
            choice.name.toLowerCase().indexOf(term) > -1 ||
            choice.accountId == this_component.manualId
          ) {
            suggestions.push(choice);

            //&& (choice.name).toLowerCase().indexOf('manual') > -1
          }
        }

        if (
          suggestions.length == 1 &&
          this_component.manualId == this_component.id.value
        ) {
          suggestions = [];
        }
        if (this_component.manualId != this_component.id.value) {
          this_component.ID = '';
        }

        suggest(suggestions);
      },
      renderItem: function(item, search) {
        //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
        return (
          '<div class="autocomplete-suggestion' +
          (item.accountId == this_component.manualId ? " manual" : "") +
          '" data-id="' +
          item.accountId +
          '"data-country="' +
          item.address1_Country +
          '"data-state="' +
          item.address1_StateOrProvince +
          '" data-name="' +
          item.name +
          '" data-val="' +
          search +
          '">' +
          (item.accountId == this_component.manualId
            ? item.name
            : item.name + " - " + item.address1_StateOrProvince) +
          "</div>"
        );
      },
      onSelect: function(e, term, item) {
        if (item.data("id") == this_component.manualId) {
          this_component.globalDomOpsService.notify(
            "Please submit the details of the new program you would like to add",
            `Medical School not found`,
            "warning"
          );
        }
        this_component.updatemodel(item);
      }
    });
  }

  static buildForm(
    acc: any | MedicalSchool | Residency | Fellowship,
    fb: FormBuilder,
    validate: boolean = true
  ) {
    return fb.group({
      name: [acc.name, validate ? [Validators.required] : []],
      id: [acc.id]
    });
  }
}
